module.exports = "pegasus/assets/tech/realty/100.png";